import { safeAwait } from 'utils/request'

export const getSinyiSiteResources = () => {
  const url = 'https://www2.sinyi.com.tw/footer/footer_sinyiother.json'
  return safeAwait(fetch(url).then((response) => response.json()))
}
